import { ref, computed } from '@vue/composition-api'
import { debounce } from 'lodash'
import axios from '@axios'

export default function useUnitSearch() {
  const results = ref([])
  const pinned = ref([])
  const loadingUnits = ref(false)

  const toOption = unit => ({ value: unit.id, label: unit.description })

  const unitOptions = computed(() => {
    const ids = new Set(results.value.map(o => o.value))
    return [...pinned.value.filter(o => !ids.has(o.value)), ...results.value]
  })

  const searchUnits = async (query = '') => {
    loadingUnits.value = true
    try {
      const params = { max: 50, sortBy: 'description', sortDesc: false }
      if (query && String(query).trim() !== '') params.q = query
      const { data } = await axios.get('v1/unit', { params })
      results.value = (data && data.success ? data.data : []).map(toOption)
    } catch (_) {
      results.value = []
    } finally {
      loadingUnits.value = false
    }
  }

  const onUnitSearch = debounce((query, loading) => {
    Promise.resolve(searchUnits(query)).finally(() => {
      if (typeof loading === 'function') loading(false)
    })
  }, 450)

  const pinUnits = values => {
    const list = (Array.isArray(values) ? values : [values]).filter(
      v => v != null && v !== ''
    )
    const byId = new Map(pinned.value.map(o => [o.value, o]))

    list.forEach(v => {
      if (typeof v === 'object' && v) {
        byId.set(v.value, { value: v.value, label: v.label })
        return
      }
      if (byId.has(v)) return
      const found = results.value.find(o => o.value === v)
      byId.set(v, found || { value: v, label: `PMI ${v}` })
    })

    pinned.value = [...byId.values()]
  }

  return {
    unitOptions,
    loadingUnits,
    searchUnits,
    onUnitSearch,
    pinUnits,
  }
}